/*
NOTE: 
1. Use effect for search customer
https://www.udemy.com/course/react-the-complete-guide-incl-redux/learn/lecture/25599220#overview

2. async/await => Promise
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function

Reference: 
DatePicker: https://reactdatepicker.com/

*/

import {
  Fragment,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  createRef,
  forwardRef,
} from "react";
import _workStepServices from "../../services/workStepServices";
import customerServices from "../../services/customerServices";
import orderServices from "../../services/orderServices";
import CustomerAdd from "../Customer/CustomerAdd";
import ModalForForms from "../Modals/ModalForForms";
// import AssignClothToTailorReq from "./../../Models/AssignClothToTailorReq";
import assignClothReq from "../../Models/assignClothReq";

import OrderRow from "../Home/OrderRow";
import { Redirect, history } from "react-router";
import { Routes, Route, useNavigate } from "react-router-dom";
// React Notification
import { NotificationManager } from "react-notifications";
import useTranslation from "../../customHooks/translations";
import DropdownFromEnum from "../../Utils/DropdownFromEnum";
import { searchTypeEnum } from "../../enums/enums"; // Import the enum
import _CustomerDetailShow from "../Customer/_CustomerDetailShow";
import DDLstuff from "../../Utils/DDLcommon";
import { Formik, Form } from "formik";
import FormikControl from "../CustomedFields/FormikControl";

import { useSelector, useDispatch } from "react-redux";
import {
  clear_AssignToTailorStore,
  removeClothAssignToTailorStore,
  add_ClothAssignToTailorStoreAtBottom,
  assign_ClothAssignToTailorStore,
  // set_TitleOfPageStore,
} from "../../slice/orderSlice";
import DDLcommon from "../../Utils/DDLcommon";
import stuffServices from "../../services/stuffServices";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import commonServices from "../../Utils/commonServices";
import { CloseButton } from "react-bootstrap";
import TitleOfPage from "../../Utils/TitleOfPage";
import { useLocation } from "react-router-dom";
// import { useHistory } from "react-router-dom";
import Popup_TakeInputValue from "./../../Utils/Popup_TakeInputValue";
import { enumWorkingSteps } from "./../../enums/enums";

const WorkSteps = () => {
  const dispatch = useDispatch();
  //Get state from store
  const {
    customerStore,
    isLoadingStore,
    clothAssignToTailorStore,
    // titleOfPageStore,
  } = useSelector((state) => state.order);

  const [selectedDate, setSelectedDate] = useState(new Date());
  //Customer
  const [enteredSearchField, setEnteredSearchField] = useState("");
  const [orderDetailList, setOrderDetailList] = useState([]);
  const [numberOfRow, setNumberOfRow] = useState("");
  const customerListHtml = [];
  const [loadingVar, setLoadingVar] = useState(false);
  const [loadingOrderVar, setLoadingOrderVar] = useState(false);
  const [selectedSearchType, setSelectedSearchType] = useState("CUSTOMER");
  const [stuffList, setStuffList] = useState([]);
  const [selectedTailorID, setSelectedTailorID] = useState("");
  const [selectedOfficeStuffID, setSelectedOfficeStuffID] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [showAddCustomerPopup, setShowAddCustomerPopup] = useState(false);
  const [submittedValue, setSubmittedValue] = useState(null);
  const [selfName, setSelfName] = useState("");

  //** Query string param */
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const param = searchParams.get("step");

  //Get date
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const isWeekday = (date) => {
    const day = date.getDay(); // getDay(date);
    return day !== 0;
  };

  // const dateNow = new Date();
  // const dateDefaultValue = dateNow.toLocaleDateString("en-CA");
  // const onInputChange = (e) => {
  //   alert(e.target.name + ", " + e.target.name);
  //   // setOrderMaster({ ...orderMaster, [e.target.name]: e.target.value });
  // };

  const translation = useTranslation();
  const navigate = useNavigate();
  // (2) Load customer list

  // (**) customer search field value change
  const onChangeOfSearchTrackingNo = (e) => {
    setEnteredSearchField(e.target.value);
  };

  const onKeyDown_searchOrderDetail = (e) => {
    if (e.key === "Enter") {
      console.log("e.target.value  : " + e.target.value);
      e.preventDefault();
      if (
        e.target.value.length != 0 &&
        e.target.value !== "" &&
        e.target.value !== null &&
        e.target.value !== "undefined"
      ) {
        seachOrderDetails();
        // setEnteredSearchField(e.target.value);
        console.log("search entered: " + e.target.value);
      } else {
      }
    }
  };

  const firstUpdate = useRef(true);

  const seachOrderDetails = async () => {
    setLoadingVar(true);
    await onSearch_SetOrderDetailList();
    setLoadingVar(false);
  };

  // 1. Search By Tracking NO
  const onSearch_SetOrderDetailList = async () => {
    console.log("Load Order details search-------");
    let orderDetailsSearched = await orderServices.getOrderDetailVMByTrackingNo(
      enteredSearchField
    );
    // debugger;
    console.log(
      "searched orderDetailsSearched ----------> " +
        JSON.stringify(orderDetailsSearched[0])
    );
    if (orderDetailsSearched !== null && orderDetailsSearched.length > 0) {
      //add to list (show in grid table)
      addItemToArray(orderDetailsSearched[0]);
      // clear text box of search
      clearSearchField();
      console.log(
        "after add orderDetailList  ----------> " +
          JSON.stringify(orderDetailList.length + ", " + orderDetailList)
      );
    }
  };

  // Function to add an item to the array
  const addItemToArray = (item) => {
    // console.log("---> new item: " + JSON.stringify(item));
    const newItem = { ...item, self: selfName };
    //alert("---> new item: " + JSON.stringify(newItem));

    setOrderDetailList((prevArray) => [...prevArray, newItem]);
    //NOTE: if already exist, don't add in list
    let searchAlreadyExist = clothAssignToTailorStore.filter(
      (orderDetails) =>
        orderDetails.orderDetailID_GUID === item.orderDetailID_GUID
    );
    if (searchAlreadyExist.length > 0) {
      // don't add already exist
    } else {
      dispatch(add_ClothAssignToTailorStoreAtBottom(newItem));
    }
  };

  // // 1. Search By Tracking NO
  // const onSearch_SetOrderDetailList = async () => {
  //   console.log("Load Order details search-------");
  //   let orderDetailsSearched = await orderServices.getOrderDetailVMByTrackingNo(
  //     enteredSearchField
  //   );
  //   // debugger;
  //   console.log(
  //     "searched orderDetailsSearched ----------> " +
  //       JSON.stringify(orderDetailsSearched[0])
  //   );
  //   if (orderDetailsSearched !== null && orderDetailsSearched.length > 0) {
  //     //add to list (show in grid table)
  //     addItemToArray(orderDetailsSearched[0]);
  //     // clear text box of search
  //     // clearSearchField();
  //     console.log(
  //       "after add orderDetailList  ----------> " +
  //         JSON.stringify(orderDetailList.length + ", " + orderDetailList)
  //     );
  //   }
  // };

  useLayoutEffect(() => {
    //** Dont' run for First time */
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    //(1) search
    // const identifier = setTimeout(async () => {
    //   setLoadingVar(true);
    //   await onSearch_SetOrderDetailList();
    //   setLoadingVar(false);
    // }, 500);

    // (2) clear setTime out
    // return () => {
    //   console.log("clear timeout");
    //   clearTimeout(identifier);
    // };
  }, []);

  useEffect(() => {
    // alert("Load again....");
    const getStuffs = async () => {
      let allStuffs = await stuffServices.getAllStuffs();
      setStuffList(allStuffs);

      // alert(allStuffs[0]?.name);
      console.log(
        "searched Measurement Settings ----------> " + allStuffs?.length
      );
    };
    getStuffs();
  }, []);

  //********************************** Add Customer */

  const childSubmitButton = useRef(); // forwardRef(); // useRef(null);

  //** Save Data...... */
  const ValidateSave = () => {
    // console.log(
    //   "selectedTailorID " +
    //     selectedTailorID +
    //     ",  selectedOfficeStuffID" +
    //     selectedOfficeStuffID +
    //     ", clothAssignToTailorStore : " +
    //     JSON.stringify(clothAssignToTailorStore)
    // );

    if (
      (selectedTailorID === null ||
        selectedTailorID === "0" ||
        selectedTailorID === "") &&
      param === enumWorkingSteps.assignClothToTailor.toString()
    ) {
      NotificationManager.warning("Please select a tailor", "Warning", 4000);
      return false;
    } else if (
      selectedOfficeStuffID === "0" ||
      selectedOfficeStuffID === null ||
      selectedOfficeStuffID === ""
    ) {
      NotificationManager.warning(
        "Please select an office stuff",
        "Warning",
        4000
      );
      return false;
    } else if (
      clothAssignToTailorStore === null ||
      clothAssignToTailorStore.length <= 0
    ) {
      NotificationManager.warning("Please select cloth items", "Warning", 4000);
      return false;
    }

    return true;
  };

  const onSave = async (values) => {
    try {
      if (!ValidateSave()) {
        return false;
      }
      setSubmittedValue(values);

      //** Comment taking PopUp, only workStep = 3 */
      if (param === enumWorkingSteps.deliverClothToCustomer.toString()) {
        handleOpenPopup();
        return false;
      }

      // save to Table
      saveToTable("");
    } catch (error) {
      //let kk = error;
    } finally {
      setIsSubmitting(false);
    }
  };

  const saveToTable = async (commentOnClothDelivery) => {
    try {
      setIsSubmitting(true);

      let objToSave = new assignClothReq();
      // debugger;
      if (param === enumWorkingSteps.deliverClothToCustomer.toString()) {
        objToSave.OtherInformation = commentOnClothDelivery;
      } else if (
        param === enumWorkingSteps.receiveReadyClothFromTailor.toString()
      ) {
        objToSave.OtherInformation = selfName;
      }

      objToSave.WorkStepTypeID = param;
      objToSave.ResponsibleFirstPartyID = selectedOfficeStuffID; // props.customerGUID;
      objToSave.ResponsibleSecondPartyID = selectedTailorID;
      objToSave.Date = selectedDate;
      objToSave.OraderDetailID_GUID_List = clothAssignToTailorStore.map(
        (item) => ({
          orderDetailID_GUID: item.orderDetailID_GUID,
          orderDetailID: item.orderDetailID,
          self: item.self,
        })
      );

      console.log("assignClothToTailorToSave :" + JSON.stringify(objToSave));

      let result = await _workStepServices.saveWorkingStep(objToSave);

      console.log("result form api: " + JSON.stringify(result));

      //Update  // clear_AssignToTailorStore
      if (result !== null && result === true) {
        //Clear
        clearForm();
        //Notification
        NotificationManager.success(
          result?.Message,
          "Saved Successfully",
          4000
        );
      } else {
        //Notification
        NotificationManager.warning(result?.Message, "Saved failed", 4000);
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  const clearForm = () => {
    //(1)
    setSelectedDate(new Date());
    clearSearchField();
    //(2)
    dispatch(clear_AssignToTailorStore());
  };

  const removeItem = (orderDetailID_GUID) => {
    confirmationOnDeleteClick()
      .then((concent) => {
        if (concent) {
          console.log(
            "remove orderDetailID_GUID --> : " +
              orderDetailID_GUID +
              "  length: " +
              clothAssignToTailorStore.length
          );
          dispatch(
            removeClothAssignToTailorStore({
              orderDetailID_GUID: orderDetailID_GUID,
            })
          );
          console.log("after remove : " + clothAssignToTailorStore.length);
        }
      })
      .catch((error) => {
        console.error("Promise rejected:", error);
      });
  };

  //***    Remove measurements Item */
  async function confirmationOnDeleteClick() {
    const confirmation = window.confirm(
      "Are you sure you want to remove this?"
    );
    return confirmation;
  }

  const setDDLTailorSelectedValue = (slectedID, selectedValue) => {
    // alert("slectedID, selectedValue : " + slectedID + " , " + selectedValue);
    setSelectedTailorID(slectedID);
  };

  const setDDLOfficeStuffSelectedValue = (slectedID, selectedValue) => {
    // alert("slectedID, selectedValue : " + slectedID + " , " + selectedValue);
    setSelectedOfficeStuffID(slectedID);
  };

  const clearSearchField = () => {
    setEnteredSearchField("");
  };

  //***    PopUp take input */

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [inputPopupText, setInputPopupText] = useState("");

  const handleOpenPopup = () => {
    setPopupOpen(true);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const onSavePopupInputCallBack = (textValue) => {
    console.log("Text input:  back...", textValue);
    setInputPopupText(textValue);
    // alert(inputPopupText);
    // save to Table
    saveToTable(textValue);
  };

  //** Self of CLoth */
  const onSelfNameChange = (e) => {
    // 1. change all item of array which are n't changed
    const clothAssignToTailorStore_new = clothAssignToTailorStore.map((item) =>
      item.self === selfName ? { ...item, self: e.target.value } : item
    );
    // alert(JSON.stringify(clothAssignToTailorStore_new));
    dispatch(assign_ClothAssignToTailorStore(clothAssignToTailorStore_new));

    //2. Set new value to state.
    setSelfName(e.target.value);
    console.log("Self Name added... " + e.target.value);
  };

  const onSelfNameChange_SpecificRow = (e, orderDetailID) => {
    // alert(e.target.value);
    const clothAssignToTailorStore_new = clothAssignToTailorStore.map((item) =>
      item.orderDetailID === orderDetailID
        ? { ...item, self: e.target.value }
        : item
    );
    // alert(JSON.stringify(clothAssignToTailorStore_new));
    dispatch(assign_ClothAssignToTailorStore(clothAssignToTailorStore_new));
    // alert(JSON.stringify(clothAssignToTailorStore));
  };

  return (
    <Fragment>
      <Popup_TakeInputValue
        onSavePopupInputCallBack={onSavePopupInputCallBack}
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
      />

      {/* ModalPopUp for customer add */}
      {/* {true && (
        <ModalForForms
          title="Add Customer"
          // setShowAddCustomerPopup={setShowAddCustomerPopup}
          // submitFromModalParent={submitFromModalParent}
        >
          <input type="text" value="dddd" />
        </ModalForForms>
      )} */}

      <div style={{ clear: "both" }}></div>
      {param === enumWorkingSteps.assignClothToTailor.toString() && (
        <TitleOfPage title={translation.assignClothToTailor} />
      )}
      {param === enumWorkingSteps.receiveReadyClothFromTailor.toString() && (
        <TitleOfPage title={translation.receiveReadyCloth} />
      )}
      {param === enumWorkingSteps.deliverClothToCustomer.toString() && (
        <TitleOfPage title={translation.deliverClothToCustomer} />
      )}

      <div style={{ clear: "both" }}></div>
      <div className="row">
        <div
          className="col-lg-11 padding3px"
          style={{ margin: "0 auto !important", height: "100vh" }}
        >
          <div className="card padding5">
            <div className="card-body padding0">
              {/* Add New Order and Customer  */}
              {(param === enumWorkingSteps.assignClothToTailor.toString() ||
                param ===
                  enumWorkingSteps.receiveReadyClothFromTailor.toString() ||
                param ===
                  enumWorkingSteps.deliverClothToCustomer.toString()) && (
                <div className="" style={{ float: "right" }}>
                  <button
                    onClick={() => onSave()}
                    disabled={isSubmitting}
                    className="btn btn-primary px-3"
                    id="submitButton"
                    type="submit"
                    // style={{
                    //   display: disabledAfterSuccessfullSubmitting
                    //     ? "none"
                    //     : "block",
                    // }}
                  >
                    {isSubmitting ? "Saving..." : "Save"}
                  </button>
                </div>
              )}

              {/* <div style={{ clear: "both" }}></div> */}
              {/* <!-- Customer search Bar --> */}
              <div className="card-title margin0" style={{ float: "left" }}>
                <div style={{ float: "left" }}>
                  <h4>
                    {translation.cloth_Items} ({clothAssignToTailorStore.length}
                    )
                  </h4>
                </div>
                <div style={{ float: "left", marginLeft: "20px" }}>
                  {loadingVar && <span>Loading...</span>}
                </div>
              </div>

              <div style={{ clear: "both", marginTop: "10px" }}>
                &nbsp; &nbsp;{" "}
              </div>

              {/* Search Option */}
              <div className="input-group icons">
                {param === enumWorkingSteps.assignClothToTailor.toString() && (
                  <>
                    <label style={{ padding: "10px" }} for="ddlSeelectTailor">
                      Tailor:
                    </label>
                    <DDLcommon
                      id="idDLLTailor"
                      style={{ width: "150px" }}
                      showDefaultOption={true}
                      defaultValue="0"
                      defaultLabel="--Select Tailor--"
                      sourceList={stuffList
                        .filter((stuff) => stuff.stuffTypeID === 3)
                        .map((item) => ({
                          id: item.stuffID_GUID,
                          name: item.name,
                        }))}
                      setSelectedValue={setDDLTailorSelectedValue}
                    />
                  </>
                )}

                {/* <button
                  style={{ padding: "10px" }}
                  onClick={() => AddCustomerPopup()}
                >
                  <i className="fa fa-search"></i>
                </button> */}

                <label style={{ padding: "10px" }} for="ddlSeelectTailor">
                  Responsible:
                </label>
                <DDLcommon
                  id="idDLLOfficeStuff"
                  style={{ width: "150px" }}
                  showDefaultOption={true}
                  defaultValue="0"
                  defaultLabel="--Select Responsible--"
                  sourceList={stuffList
                    .filter((stuff) => stuff.stuffTypeID === 2)
                    .map((item) => ({
                      id: item.stuffID_GUID,
                      name: item.name,
                    }))}
                  setSelectedValue={setDDLOfficeStuffSelectedValue}
                />

                <label style={{ padding: "10px" }} for="ddlSeelectTailor">
                  Date:
                </label>
                <div style={{ width: "200px" }}>
                  <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    showTimeSelect
                    // dateFormat="Pp"
                    dateFormat="dd/MM/yyyy HH:mm:ss"
                    //timeFormat="HH:mm:ss"
                    showIcon
                    icon="fa fa-calendar"
                    // isClearable
                    placeholderText="Enter date"
                    className="red-border"
                    // timeClassName={handleColor}
                    shouldCloseOnSelect={true}
                    filterDate={isWeekday}
                    // highlightDates={[subDays(new Date(), 7), addDays(new Date(), 7)]}
                    highlightDates={[commonServices.addDays(new Date(), 7)]}
                    // holidays={[
                    //   { date: "2023-12-16", holidayName: "Victory Day" },
                    //   { date: "2023-12-31", holidayName: "New Year's Eve" },
                    //   { date: "2023-12-25", holidayName: "Christmas" },
                    //   { date: "2024-01-01", holidayName: "New Year's Day" },
                    //   { date: "2023-11-23", holidayName: "Thanksgiving Day" },
                    //   { date: "2023-12-25", holidayName: "Fake holiday" },
                    // ]}
                    // withPortal
                  >
                    <div style={{ color: "red", textAlign: "center" }}>
                      Please select a date
                    </div>
                  </DatePicker>
                </div>

                {/* <FormikControl
                  control="input"
                  type="date"
                  label="Order Date"
                  name="orderDate"
                  dateFormat="dd/MM/yyyy"
                  //value={dateNow}
                  // onChange={(e) => onInputChange(e)}
                /> */}

                <label style={{ padding: "10px" }} for="ddlSeelectTailor">
                  Enter Tracking No:
                </label>
                <input
                  value={enteredSearchField}
                  type="search"
                  className="form-control"
                  placeholder={translation.search_trackingNos}
                  aria-label="Search Tracking No"
                  onChange={onChangeOfSearchTrackingNo}
                  onKeyDown={onKeyDown_searchOrderDetail}
                ></input>
              </div>
              <div style={{ clear: "both", marginTop: "1px" }}>
                &nbsp; &nbsp;{" "}
              </div>

              <div className="table-responsive, customerSearchDiv">
                {/* Show Order Detail (Cloth Item) List */}
                <table className="table">
                  <thead>
                    <tr>
                      <th>{translation.si}</th>
                      {param ===
                        enumWorkingSteps.receiveReadyClothFromTailor.toString() && (
                        <th>
                          <input value={selfName} onChange={onSelfNameChange} />
                        </th>
                      )}
                      <th style={{ width: "200px" }}>{translation.name}</th>
                      <th>{translation.phone}</th>
                      <th>{translation.orderNumber}</th>
                      <th>{translation.trackingNumber}</th>
                      <th>{translation.item}</th>
                      <th>{translation.Qty}</th>
                      <th>{translation.note}</th>
                      <th>{translation.OrderDate}</th>
                      <th>{translation.delivery_date}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {orderDetailList.map((cus, i) => ( */}
                    {clothAssignToTailorStore.map((cus, i) => (
                      <tr key={i}>
                        <th>{i + 1}</th>
                        {param ===
                          enumWorkingSteps.receiveReadyClothFromTailor.toString() && (
                          <td>
                            <input
                              value={cus.self}
                              placeholder="Cloth Self"
                              onChange={(e) =>
                                onSelfNameChange_SpecificRow(
                                  e,
                                  cus.orderDetailID
                                )
                              }
                            />
                          </td>
                        )}

                        <td>{cus.customerName}</td>
                        <td>{cus.cellNo}</td>
                        <td>{cus.orderID}</td>
                        <td>{cus.orderDetailID}</td>
                        <td>{cus.name}</td>
                        <td>{cus.qty}</td>
                        <td>{cus.note}</td>
                        <td>{cus.orderDate}</td>
                        <td>{cus.deliveryDate}</td>
                        <td>
                          <button
                            onClick={() => removeItem(cus.orderDetailID_GUID)}
                          >
                            <span className="badge badge-danger px-2">
                              {translation.Remove}
                            </span>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default WorkSteps;
